import React from 'react';
import { FiCalendar, FiArrowLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import SEO from '../../../components/SEO';

const BestClothingStyles2026 = () => {
    return (
        <div className="bg-white min-h-screen pb-24">
            <SEO
                title="Best Clothing Styles in Sri Lanka 2026"
                description="Discover the hottest fashion trends set to dominate the Sri Lankan streets in 2026. From sustainable silks to modern batik."
                url="/blog/best-clothing-styles-2026"
            />
            <div className="max-w-4xl mx-auto px-4 pt-24">
                <Link to="/blog" className="inline-flex items-center text-slate-500 hover:text-slate-900 mb-8 transition-colors">
                    <FiArrowLeft className="mr-2" /> Back to Blog
                </Link>

                <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
                    Best clothing styles in Sri Lanka 2026
                </h1>

                <div className="flex items-center text-slate-500 mb-12">
                    <FiCalendar className="mr-2" /> April 27, 2024
                </div>

                <img
                    src="/images/hip_hop_swag.png"
                    alt="Fashion Trends 2026"
                    className="w-full h-[500px] object-cover rounded-3xl mb-12 shadow-sm"
                />

                <div className="prose prose-lg max-w-none text-gray-600 leading-relaxed">
                    <p className="mb-6">
                        As we approach 2026, the Sri Lankan fashion scene is undergoing a dramatic transformation. Blending traditional aesthetics with futurist trends, the island's style is more vibrant than ever. In this post, we explore the key looks that will define the year.
                    </p>

                    <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">1. Sustainable Silk and Eco-Friendly Fabrics</h2>
                    <p className="mb-6">
                        Sustainability is no longer just a buzzword; it's a lifestyle. Expect to see a rise in locally sourced, eco-friendly materials that provide both comfort and conscience.
                    </p>

                    <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">2. Modern Batik Revolutions</h2>
                    <p className="mb-6">
                        Batik is getting a contemporary makeover. Bold, geometric patterns and neon accents are replacing more traditional motifs, making it a favorite for the youth.
                    </p>

                    <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">3. Oversized Streetwear</h2>
                    <p className="mb-6">
                        The comfort-first movement continues. Oversized tees, cargo pants, and chunky sneakers remain the go-to for the Colombo street scene.
                    </p>

                    <p className="mt-12">
                        Stay ahead of the curve with Cider Clothings. We bring the latest global trends directly to Sri Lanka.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BestClothingStyles2026;
